export enum GroupStatus {
    active = 1,
    inactive = 2,
    disabled_by_support = 3
}
